const MIN_VALUE = 60;
const MAX_VALUE = 100;
function getRandomSkeletonPercentageWidth() {
  return `${Math.random() * (MAX_VALUE - MIN_VALUE) + MIN_VALUE}%`;
}
export { getRandomSkeletonPercentageWidth };